import React from 'react';

/**
 * MobileWrapper - Centers content in a mobile-sized container on desktop
 * This ensures the app looks good on desktop by constraining it to mobile dimensions
 */
const MobileWrapper = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-start justify-center">
      {/* Mobile container - max 430px width on desktop */}
      <div 
        className={`w-full max-w-[430px] min-h-screen bg-white relative shadow-2xl ${className}`}
        style={{ 
          // Ensure the container takes full height on mobile
          minHeight: '100dvh'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MobileWrapper;
